/* GRILIAI.LT Black Friday 2026: laikmačiai, lipni juosta, skirtukai, karuselės, grilio parinkiklis, popup, inkarų nuorodos */
(function () {
  'use strict';
  if (window.__bf2026) return;
  window.__bf2026 = true;

  var timers = [];
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function store(type) {
    try { var s = window[type]; var k = '__bf'; s.setItem(k, '1'); s.removeItem(k); return s; } catch (e) { return null; }
  }
  var local = store('localStorage');
  var session = store('sessionStorage');

  /* Inkarų nuorodos (/#rinktis-grili, /#nuolaidos) tame pačiame puslapyje.
     Temos puslapio perėjimo animacija tokias nuorodas laiko nauju puslapiu ir palieka juodą uždangą,
     todėl joms pridedame .no-transition ir slenkame patys, atsižvelgdami į lipnų header'į. */
  function headerOffset() {
    var off = 0;
    var header = document.querySelector('[id*="__header"]');
    if (header) off = Math.max(0, header.getBoundingClientRect().bottom);
    return Math.min(off || 120, 220) + 16;
  }
  function samePageTarget(a) {
    var url;
    try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return null; }
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.hash.length < 2) return null;
    var el = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    return el ? { el: el, hash: url.hash } : null;
  }
  function scrollToEl(el, smooth) {
    var top = Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - headerOffset());
    var start = window.pageYOffset;
    window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
    if (smooth) setTimeout(function () {
      if (Math.abs(window.pageYOffset - start) < 4 && Math.abs(top - start) > 4) window.scrollTo(0, top);
    }, 450);
  }
  function markAnchors(root) {
    root.querySelectorAll('a[href*="#"]').forEach(function (a) { if (samePageTarget(a)) a.classList.add('no-transition'); });
  }
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a || a.target === '_blank') return;
    var t = samePageTarget(a);
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var pop = a.closest('[data-bf-popup]');
    if (pop) {
      if (local) local.setItem('bf-popup-' + (pop.getAttribute('data-key') || '2026'), String(Date.now()));
      var c = pop.querySelector('.bf-pop__close');
      if (c) c.click();
    }
    if (history.replaceState) history.replaceState(null, '', t.hash);
    scrollToEl(t.el, true);
  }, true);
  window.addEventListener('load', function () {
    var h = window.location.hash;
    if (h && h.length > 1) {
      var el = document.getElementById(decodeURIComponent(h.slice(1)));
      if (el) setTimeout(function () { scrollToEl(el, false); }, 150);
    }
  });

  function initCountdowns(root) {
    root.querySelectorAll('[data-bf-countdown]:not([data-bf-ready])').forEach(function (el) {
      el.setAttribute('data-bf-ready', '');
      var end = Date.parse(el.getAttribute('data-end'));
      if (isNaN(end)) return;
      timers.push({ el: el, end: end, d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') });
    });
    tick();
  }
  function tick() {
    var now = Date.now();
    timers.forEach(function (t) {
      var left = Math.max(0, Math.floor((t.end - now) / 1000));
      if (t.d) t.d.textContent = pad(Math.floor(left / 86400));
      if (t.h) t.h.textContent = pad(Math.floor((left % 86400) / 3600));
      if (t.m) t.m.textContent = pad(Math.floor((left % 3600) / 60));
      if (t.s) t.s.textContent = pad(left % 60);
      if (!left && !t.done) { t.done = true; t.el.classList.add('is-expired'); }
    });
  }
  setInterval(tick, 1000);

  function initSticky() {
    var bar = document.querySelector('[data-bf-sticky]');
    if (!bar || bar.hasAttribute('data-bf-ready')) return;
    bar.setAttribute('data-bf-ready', '');
    if (session && session.getItem('bf-sticky-closed') === '1') return;
    var closed = false;
    bar.hidden = false;
    var btn = bar.querySelector('[data-bf-sticky-close]');
    if (btn) btn.addEventListener('click', function () {
      closed = true;
      bar.classList.remove('is-visible');
      if (session) session.setItem('bf-sticky-closed', '1');
    });
    var hero = document.querySelector('[data-bf-hero]');
    if (!hero || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    new IntersectionObserver(function (entries) {
      if (!closed) bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }).observe(hero);
  }

  function updateRail(rail) {
    if (!rail) return;
    var track = rail.querySelector('[data-bf-track]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    rail.querySelectorAll('[data-bf-dir]').forEach(function (b) {
      b.disabled = b.getAttribute('data-bf-dir') === '-1' ? track.scrollLeft <= 2 : track.scrollLeft >= max;
    });
  }
  function initRails(root) {
    root.querySelectorAll('[data-bf-rail]:not([data-bf-ready])').forEach(function (rail) {
      rail.setAttribute('data-bf-ready', '');
      var track = rail.querySelector('[data-bf-track]');
      if (!track) return;
      rail.querySelectorAll('[data-bf-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          track.scrollBy({ left: track.clientWidth * 0.9 * Number(b.getAttribute('data-bf-dir')), behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', function () { updateRail(rail); }, { passive: true });
      updateRail(rail);
    });
  }
  window.addEventListener('resize', function () { document.querySelectorAll('[data-bf-rail]').forEach(updateRail); });

  function initTabs(root) {
    root.querySelectorAll('[data-bf-tabs]:not([data-bf-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-bf-ready', '');
      var tabs = wrap.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            var p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) updateRail(panel.querySelector('[data-bf-rail]'));
        });
      });
    });
  }

  /* "WEBER=-10%" eilutės -> {weber: '-10%'}; "*" – visiems kitiems gamintojams */
  function parseVendors(text) {
    var map = {};
    (text || '').split(/[\n,;]+/).forEach(function (line) {
      var i = line.lastIndexOf('=');
      if (i > 0) map[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
    });
    return map;
  }

  function initFinder(root) {
    root.querySelectorAll('[data-bf-finder]:not([data-bf-ready])').forEach(function (f) {
      f.setAttribute('data-bf-ready', '');
      var grid = f.querySelector('[data-bf-grid]');
      var summary = f.querySelector('[data-bf-summary]');
      var more = f.querySelector('[data-bf-more]');
      var vendors = parseVendors(f.getAttribute('data-vendors'));
      var limit = parseInt(f.getAttribute('data-limit') || '8', 10);
      var cache = {};
      var seq = 0;

      f.querySelectorAll('[data-bf-opt]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.getAttribute('data-bf-opt');
          var wasOn = btn.getAttribute('aria-pressed') === 'true';
          f.querySelectorAll('[data-bf-opt="' + group + '"]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          if (!(wasOn && btn.hasAttribute('data-toggle'))) btn.setAttribute('aria-pressed', 'true');
          run();
        });
      });

      function pick(group) { return f.querySelector('[data-bf-opt="' + group + '"][aria-pressed="true"]'); }
      function state() {
        var t = pick('tier'), c = pick('coll'), b = pick('budget'), v = pick('vendor');
        return {
          tier: t ? t.getAttribute('data-value') : '',
          coll: c ? c.getAttribute('data-value') : f.getAttribute('data-fallback'),
          min: b ? b.getAttribute('data-min') : '',
          max: b ? b.getAttribute('data-max') : '',
          vendor: v ? v.getAttribute('data-value') : ''
        };
      }
      function url(s, section) {
        var p = [];
        if (section) p.push('section_id=bf-grill-finder-results');
        p.push('sort_by=best-selling');
        if (s.min) p.push('filter.v.price.gte=' + encodeURIComponent(s.min));
        if (s.max) p.push('filter.v.price.lte=' + encodeURIComponent(s.max));
        if (s.vendor) p.push('filter.p.vendor=' + encodeURIComponent(s.vendor));
        return s.coll + (s.coll.indexOf('?') > -1 ? '&' : '?') + p.join('&');
      }
      function skeleton() {
        var h = '';
        for (var i = 0; i < Math.min(limit, 8); i++) h += '<div class="bf-skel" aria-hidden="true"></div>';
        return h;
      }
      function run() {
        var s = state();
        if (!s.coll) return;
        if (more) more.href = url(s, false);
        var u = url(s, true);
        var my = ++seq;
        grid.setAttribute('aria-busy', 'true');
        grid.innerHTML = skeleton();
        if (!cache[u]) cache[u] = fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
        cache[u].then(function (html) { if (my === seq) render(html, s); }).catch(function () {
          delete cache[u];
          if (my !== seq) return;
          grid.removeAttribute('aria-busy');
          grid.innerHTML = '<p class="bf-finder__empty">Nepavyko įkelti pasiūlymų. <a href="' + (more ? more.href : s.coll) + '">Žiūrėti kolekcijoje</a></p>';
        });
      }
      function render(html, s) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = Array.prototype.slice.call(doc.querySelectorAll('[data-bf-gcard]'));
        var min = s.min ? parseFloat(s.min) : 0;
        var max = s.max ? parseFloat(s.max) : Infinity;
        cards = cards.filter(function (c) {
          var p = parseFloat(c.getAttribute('data-price'));
          if (!isNaN(p) && (p < min || p > max)) return false;
          if (s.vendor && (c.getAttribute('data-vendor') || '').toLowerCase() !== s.vendor.toLowerCase()) return false;
          return true;
        });
        var list = cards;
        if (s.tier) {
          var t = parseInt(s.tier, 10);
          var exact = cards.filter(function (c) { return c.getAttribute('data-tier') === String(t); });
          list = exact;
          if (exact.length < 4) {
            list = exact
              .concat(cards.filter(function (c) { return c.getAttribute('data-tier') === String(t + 1); }))
              .concat(cards.filter(function (c) { return !c.getAttribute('data-tier'); }));
          }
        }
        grid.innerHTML = '';
        list.slice(0, limit).forEach(function (c) {
          var node = document.importNode(c, true);
          var flag = node.querySelector('[data-bf-flag]');
          var pct = vendors[(c.getAttribute('data-vendor') || '').toLowerCase()] || vendors['*'];
          if (flag && pct) { flag.textContent = 'BF ' + pct; flag.hidden = false; }
          grid.appendChild(node);
        });
        if (!list.length) {
          grid.innerHTML = '<p class="bf-finder__empty">' + (f.getAttribute('data-empty') || '') + '</p>';
        }
        if (summary) {
          summary.innerHTML = list.length
            ? (f.getAttribute('data-found') || '').replace('[n]', '<strong>' + list.length + (list.length >= 50 ? '+' : '') + '</strong>')
            : '';
        }
        grid.removeAttribute('aria-busy');
      }
      run();
    });
  }

  function initPopup() {
    var pop = document.querySelector('[data-bf-popup]');
    if (!pop || pop.hasAttribute('data-bf-ready')) return;
    pop.setAttribute('data-bf-ready', '');
    var design = pop.hasAttribute('data-design-mode');
    var key = 'bf-popup-' + (pop.getAttribute('data-key') || '2026');
    var days = parseFloat(pop.getAttribute('data-days') || '1');
    var end = Date.parse(pop.getAttribute('data-end'));
    if (!isNaN(end) && Date.now() > end && !design) return;
    var last = local ? parseInt(local.getItem(key) || '0', 10) : 0;
    if (!design && last && Date.now() - last < days * 864e5) return;
    var lastFocus = null;
    function remember() { if (local) local.setItem(key, String(Date.now())); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    function open() {
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      document.addEventListener('keydown', onKey);
      var c = pop.querySelector('.bf-pop__close');
      if (c) c.focus({ preventScroll: true });
    }
    function close() {
      pop.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { pop.hidden = true; }, 300);
      remember();
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    pop.addEventListener('click', function (e) {
      if (e.target === pop || e.target.closest('[data-bf-popup-close]')) close();
    });
    pop.querySelectorAll('[data-bf-popup-cta]').forEach(function (a) { a.addEventListener('click', remember); });
    document.addEventListener('shopify:section:select', function (e) { if (pop.closest('.shopify-section') === e.target) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (pop.closest('.shopify-section') === e.target) close(); });
    if (!design) setTimeout(open, parseFloat(pop.getAttribute('data-delay') || '5') * 1000);
  }

  function init(root) {
    markAnchors(root);
    initCountdowns(root);
    initTabs(root);
    initRails(root);
    initFinder(root);
  }
  function boot() {
    init(document);
    initSticky();
    initPopup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initSticky(); initPopup(); });
})();
